import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import Swal from 'sweetalert2';
import { EnquiryService } from '../../../_services/admin/enquiry.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-enquiry',
  templateUrl: './enquiry.component.html',
  styleUrls: ['./enquiry.component.scss']
})
export class EnquiryComponent implements OnInit {

  enquiryList: any[] = [];
  tempEnquiryList: any[] = [];
  deleteUserForm: FormGroup;
  isdeleteUserFormSubmitted = false;

  constructor(private enquiryService: EnquiryService,
    private myTitle: Title,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.myTitle.setTitle('Enquiries | ' + environment.commonTitle);
    this.getAllEnquiries();
  }

  getAllEnquiries() {
    this.enquiryService.getAllEnquiry().subscribe(result => {
      if (result.data) {
        this.enquiryList = result.data;
        this.tempEnquiryList = [...this.enquiryList];
      }
    });
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    const temp = this.tempEnquiryList.filter(function (d) {
      return d.name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    this.enquiryList = temp;
  }

  deleteEnquiry(id: number) {
    Swal({
      title: 'Are you sure you want to remove enquiry?',
      text: '',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true,
      focusConfirm: false
    }).then((res) => {
      if (res.value) {
        this.enquiryService.deleteEnquiry(id).subscribe(result => {
          if (result.data) {
            this.openSnackBar('Enquiry deleted succcessfully.', 'Success.');
            this.getAllEnquiries()
          }
        });
      } else if (res.dismiss === Swal.DismissReason.cancel) {
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }
}
